























































































































import TitleBar from '@/components/Elements/TitleBar.vue'

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { STORE_KEY, store } from './_store';
import moment from 'moment';
import ProductCombobox from '@/components/Controls/ProductCombobox.vue';
import ProductContainerCombobox from '@/components/Controls/ProductContainerCombobox.vue';

@Component({
  computed: {
    ...mapState(STORE_KEY, [
      'loading', 'loaded', 'fatalError',

      'data', 'total'
    ]),
  },
  methods: {
    ...mapActions(STORE_KEY, [
      'setReportOptions', 'exportDataAsXLSX'
    ])
  },
  components: {
    TitleBar, 
    ProductCombobox,
    ProductContainerCombobox
  }
})
export default class MarginalityByProductDetailReport extends Vue {

  get titleStack () {
    return [
      'Отчеты',
      'Потребление продуктов по клиентам'
    ]
  }

  localFilter = {
    with_container: null,
    with_archived: false,
    targetDates: [new Date(), new Date()],
    product_id: null,
    product_container_id: null,
  }
  with_archived: boolean = false
  get withContainer() {
    return this.$route.query.with_container == 'true';
  }

  public created() {
    // @ts-ignore
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  }

  public mounted() {
    // @ts-ignore
    this.localFilter.product_id = (this.$route.query && this.$route.query.product_id)? this.$route.query.product_id : null;
    // @ts-ignore
    this.localFilter.product_container_id = (this.$route.query && this.$route.query.product_container_id)? this.$route.query.product_container_id : null;
    // @ts-ignore
    this.localFilter.with_container = (this.$route.query && this.$route.query.with_container)? this.$route.query.with_container : null;
    // @ts-ignore
    this.localFilter.with_archived = (this.$route.query && this.$route.query.with_archived)? this.$route.query.with_archived : null;
    // @ts-ignore
    this.localFilter.targetDates = (this.$route.query && this.$route.query.targetDates) ? [moment(this.$route.query.targetDates[0]).toDate(), moment(this.$route.query.targetDates[1]).toDate()] : [new Date(), new Date()];

    this.handleParamsChange();
  }

  setFilterData() {
    const query = Object.keys(this.localFilter).reduce((ac: any, key) => {
      // @ts-ignore
      ac[key] = (key == 'targetDates') ? [moment(this.localFilter[key][0]).format('YYYY-MM-DD'), moment(this.localFilter[key][1]).format('YYYY-MM-DD')] : this.localFilter[key]
      return ac;
    }, {});

    this.$router.replace({
      query
    })
  }

  // ---------------------------------------------------------------------------

  @Watch('$route.query')
  public handleParamsChange() {
    this.$store.dispatch(`${STORE_KEY}/loadData`, this.$route.query);
  }

}
